module.exports = __webpack_public_path__ + "img/modal_submit.9f29ec34.png";